"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var ThemeProvider_1 = require("../../ThemeProvider");
var getColorThemeIcon = function (theme) { return function (_a) {
    var brand = _a.brand, color = _a.color;
    var themeSelectIcon = (0, ThemeProvider_1.buildTheme)(brand, 'light');
    if (brand) {
        return color && themeSelectIcon.color[color];
    }
    return color && theme.color[color];
}; };
var styles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    icon: {
        color: function (_a) {
            var color = _a.color, brand = _a.brand;
            return getColorThemeIcon(theme)({ brand: brand, color: color });
        },
        fontFamily: 'natds-icons',
        fontSize: function (_a) {
            var size = _a.size;
            return size && theme.size[size];
        },
        pointerEvents: 'none',
        userSelect: 'none'
    }
}); });
exports.default = styles;
//# sourceMappingURL=Icon.styles.js.map